<template>
  <div class="play">
    <drag>       
      <div class="work" slot='uLeft'  @click="chooseScreenLeft">
        <k-header :headerData="headerTeacher" :class="{negScreen:!negScreen}">
        </k-header>
        <div class="editor-wrap">
          <editor ref="teacherEditor" :options="editorConfig"></editor>          
        </div>
      </div>
      <div class="work" slot='dLeft' @click="chooseScreenLeft">
        <iterm isCompile="1" :options="itermPlay" :tab="tab" :inputParam="inputParam" :compileInfo="compileInfo" :class="{negScreen:!negScreen}"></iterm>
      </div>
      <div class="work bdl" slot='uRight' @click="chooseScreenRight">
        <k-header :headerData="headerStudent" :class="{negScreen:negScreen}">
          <span class="live-btn" @click="issueQA">提问</span>
          <!--<span v-show="!isLive" class="beforeLiving">未开始</span>
          <span v-show="isLive" class="underLiving ">正在进行中...</span>-->
          <span class="live-btn t-clear" @click="clearCode">清除代码</span>
          <span class="live-btn t-clear" @click="exportCode">导出代码</span>
        </k-header>
        <div class="editor-wrap">
          <editor ref="studentEditor"></editor>          
        </div>
      </div>
      <div class="work bdl" slot='dRight' @click="chooseScreenRight">
        <iterm isCompile="1" :options="itermData" :tab="tab" :inputParam="inputParam" :compileInfo="compileInfo" :class="{negScreen:negScreen}" @insertTemplate="insertData"></iterm>
      </div>
    </drag>
  </div>
</template>

<script>
/* eslint-disable */
import Drag from '@/components/Drag'
import kHeader from '@/components/Header'
import Editor from '@/components/Editor/editor'
import Iterm from '@/components/ItermV2'
import { RestoreAction, insertTemplate, exportFile, getFileName } from '@/utils/utils'
import EventBus from '@/views/eventBus'
import { getUrlParam } from '@/common/js/utils'
export default {
  components: {
    Drag,
    kHeader,
    Editor,
    Iterm
  },
  data () {
    return {
      headerTeacher: {
        role: '教学区',
        roomId: this.$route.params.roomId
      },
      headerStudent: {
        role: '编辑区'
      },
      editorConfig: {
        isWrite: false
      },
      itermPlay: {
        isCompile: false,
        infoCome: 'online'
      },
      itermData: {
        isCompile: true
      },
      tab: 0,
      inputParam: '',
      compileInfo: {},
      isLive: '',
      negScreen: true
    }
  },
  created () {
    console.log('00000')
    this.initSocket()
  },
  mounted () {
    this.studentEditor.on('change', function(instance, changeObj){
      console.log(changeObj)
    })
    this.studentEditor.setValue(localStorage.getItem('editorContent'))
  },
  computed: {
    teacherEditor() {
      return this.$refs.teacherEditor.editor
    },
    studentEditor() {
      return this.$refs.studentEditor.editor
    }
  },
  methods: {
    chooseScreenLeft () {
      this.negScreen = true
    },
    chooseScreenRight () {
      console.log('chooseScreenRight')
      this.negScreen = false
    },     
    initEditor() {
    },
    initSocket () {
      let _this = this
      this.socket.on('clear.code', (data) => {
        _this.isLive = false
        this.teacherEditor.setValue('')
      })
      this.socket.on('init.room.data', (data) => {
        console.log('init.room.data', data)
        if (data.isLive) {
          _this.isLive = true
        }
        // this.teacherEditor.setValue('')
        this.teacherEditor.setValue(data.editorContent)
      })
      this.socket.on('action.code', (data) => {
        RestoreAction(this.teacherEditor, data)
      })
      this.socket.on('start.live', () => {
        _this.isLive = true
      })  
      this.socket.on('clear.editor', function () {
        _this.isLive = false
        _this.teacherEditor.setValue('')
      })    
    },
    clearCode() {
      this.studentEditor.setValue('')
      EventBus.$emit('clearResult')
      this.$store.commit('clearAction')
    },
    insertData(language) {
      insertTemplate(language, this.studentEditor)
    },
    exportCode() {
      var content = this.studentEditor.getValue()
      var languageId = this.$route.params.languageId
      var filename = getFileName(languageId)
      exportFile(content, filename)
    },
    issueQA() {
      let data = {
        roomId: this.$route.params.roomId,
        name: getUrlParam('name'),
        code: this.studentEditor.getValue()
      }
      console.log(data)
      this.socket.emit('student.qa', data)
      this.$success('您的代码已提交给老师')
    }
  }
}
</script>

<style lang="scss">
  .play{
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    .work{
      height: 100%;
      overflow: hidden;
      .editor-wrap{
        height: calc(100% - 48px);
      }
    }
    .dragWrap{
      position: relative;
      width: 100%;
      height: calc(100% - 48px);
      overflow: hidden;
    }
    .editor, .iterm-wrap{
      width: 100%;
      height: 100%;
    }

    .negScreen{
      background: #F0F3F5;

      .info{
        span{
         color: #000;
        }
      }
      .action{
        span{
         color: #000;
        }
        .full-screen{
          img{
            display:none
          }
          background:url(../../assets/fullscreen_gray.png)
        }
      }
      .i-menu{
        background: #F0F3F5 !important;
        color:#000;

        span{
          line-height: 32px;
        }

        .web-iterm{
          color: #3D474D;
          background: url(../../assets/Triangle.png) no-repeat scroll 136px center transparent;
          border-color: #3D474D; 
          a{
            color:#000
          }         
        }
        
        .active{
          background: rgba(61, 71, 77, 0.4);
          color: #fff;
          box-shadow: 0 0;
        }
        li{
          color: #000; 
        }
        li:hover{
          background: rgba(61, 71, 77, 0.4)!important;
          color: #fff;
          box-shadow: 0 0;
        }

        .compile-btn{
          background: rgba(61, 71, 77, 0.4);
          box-shadow: 0 0;
          border-color: rgba(61, 71, 77, 0.4);
          color: #fff;
        }
      }
    }    
  }
</style>



// WEBPACK FOOTER //
// play.vue?11e59be6